import { render, staticRenderFns } from "./AdministratorsTable.vue?vue&type=template&id=b0384472&scoped=true"
import script from "./AdministratorsTable.vue?vue&type=script&lang=js"
export * from "./AdministratorsTable.vue?vue&type=script&lang=js"
import style0 from "./AdministratorsTable.vue?vue&type=style&index=0&id=b0384472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0384472",
  null
  
)

export default component.exports